import React, { ReactNode } from "react";
import useTailwindBrand from "../Theme/useTailwindBrand";
import TeachrRepository from "../Repositories/TeachrRepository";
import { store } from "../Redux/store";
import { userTeachrSetAccountAction } from "../Redux/Actions/UserActions";
import LayoutApp from "./LayoutApp";

export type LayoutVariant = "home" | "students" | "courses" | "default";

export interface LayoutProps {
  header?: ReactNode;
  children: ReactNode;
  className?: string;
  className2?: string;
  contentClassName?: string;
}

const Layout: React.FC<LayoutProps> = ({
  header,
  children,
  className,
  className2 = "rounded-lg bg-white lg:p-8 md:p-4 p-2",
  contentClassName,
}) => {
  const { classes } = useTailwindBrand();
   React.useEffect(() => {
          // tableau de bord commun : le rafraîchissement du profil prof n'a
          // pas de sens pour un client connecté
          const currentUser = (store.getState() as any)?.user?.currentUser;
          if (currentUser?.isClient || !currentUser?.isTeachr) return;
          TeachrRepository.getCurrentTeachr()
            .then((refreshedTeachr) => {
                  if (refreshedTeachr) {
                      const serializedTeachr = JSON.parse(JSON.stringify(refreshedTeachr));
                      store.dispatch(userTeachrSetAccountAction(serializedTeachr));
                  }
              }).catch((error) => console.error('error', error))
      }, []);

  return (
    <LayoutApp className2={className2} className={className} >
      {header && (
        <div className={`w-full bg-white ${classes.fontFamily} mb-4`}>
          {header}
        </div>
      )}
      <div className={contentClassName ?? `p-2 border border-gray-500/50 rounded-md ${classes.background} inset-shadow-xl inset-shadow-indigo-500/50 w-full ${classes.fontFamily}`} >
        {children}
      </div>
    </LayoutApp>
  );
};

export default Layout;
